import { utilTypes, restaurantTypes, userTypes, branchTypes } from "../types";
const initialstate = {
  message: "",
  severity: "",
  open: false,
};
let success = "success";
let error = "error";

const snackReducer = (state = initialstate, action) => {
  switch (action.type) {
    case "HIDE_SNACKBAR":
      return initialstate;
    case restaurantTypes.CREATE_RESTAURANT_SUCCESS:
      return {
        ...state,
        message: action.payload.data.message || "Success",
        severity: success,
        open: true,
      };
    case restaurantTypes.CREATE_RESTAURANT_FAIL:
      return {
        ...state,
        message: action?.error?.response?.data?.message,
        severity: error,
        open: true,
      };

    case restaurantTypes.UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        message: action.payload.data.message || "Success",
        severity: success,
        open: true,
      };

    case restaurantTypes.UPDATE_BRANCH_FAIL:
      return {
        ...state,
        message: action?.error?.response?.data?.message,
        severity: error,
        open: true,
      };

    case restaurantTypes.UPDATE_RESTAURANT_SUCCESS:
      return {
        ...state,
        message: action.payload.data.message || "Success",
        severity: success,
        open: true,
      };

    case restaurantTypes.UPDATE_RESTAURANT_FAIL:
      return {
        ...state,
        message: action?.error?.response?.data?.message,
        severity: error,
        open: true,
      };

    case branchTypes.CREATE_BRANCH_FAIL:
      return {
        ...state,
        message: action?.error?.response?.data?.message,
        severity: error,
        open: true,
      };

    case branchTypes.CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        message: action.payload.data.message || "Success",
        severity: success,
        open: true,
      };

    case restaurantTypes.GET_ALL_RESTAURANTS_FAIL:
      console.log("err msg", action?.error?.response?.data?.message);
      return {
        ...state,
        message: action?.error?.response?.data?.message,
        severity: error,
        open: true,
      };

    case userTypes.LOGOUT_USER:
      return {
        ...state,
        message: "Logged out",
        severity: success,
        open: true,
      };

    default:
      return state;
  }
};

export default snackReducer;
